import { render, staticRenderFns } from "./flight-segment-display.vue?vue&type=template&id=07bf3bfd"
import script from "./flight-segment-display.vue?vue&type=script&lang=js"
export * from "./flight-segment-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports